// 万剑阁 —— 剑玉图鉴类型定义与标签。
// 品牌与型号数据全部来自后端（由管理员在万剑阁管理面板维护），前端不再内置种子数据。

export type KendamaCategory =
  | 'entry'
  | 'competition'
  | 'signature'
  | 'limited'
  | 'standard'
  | 'premium';

export type KendamaType = 'ken' | 'tama' | 'bundle' | 'novelty';

export type LocalizedText = {
  zh: string;
  en: string;
  ja: string;
};

export type KendamaModel = {
  id: string;
  name: string;
  nameZh: string;
  nameJa: string;
  type: KendamaType;
  shape: string;
  category: KendamaCategory;
  material: string;
  paint?: string;
  image?: string;
  // 多图列表：第一张为封面（与 image 保持一致），详情弹窗可左右滑动查看。
  images?: string[];
  tags: string[];
  description: LocalizedText;
};

export type KendamaBrand = {
  id: string;
  name: string;
  nameEn?: string;
  nameZh: string;
  nameJa: string;
  country: string;
  countryZh: string;
  countryJa: string;
  accent: string;
  description: LocalizedText;
  models: KendamaModel[];
};

export const kendamaCategoryLabels: Record<KendamaCategory, LocalizedText> = {
  entry: { zh: '入门款', en: 'Entry', ja: '入門' },
  competition: { zh: '竞技款', en: 'Competition', ja: '競技' },
  signature: { zh: '签名款', en: 'Signature', ja: 'シグネチャー' },
  limited: { zh: '限定款', en: 'Limited', ja: '限定' },
  standard: { zh: '常规款', en: 'Standard', ja: 'スタンダード' },
  premium: { zh: '高端款', en: 'Premium', ja: 'プレミアム' },
};

export const kendamaTypeLabels: Record<KendamaType, LocalizedText> = {
  ken: { zh: '剑', en: 'Ken', ja: '剣' },
  tama: { zh: '球', en: 'Tama', ja: '玉' },
  bundle: { zh: '套剑', en: 'Setup', ja: 'セット' },
  novelty: { zh: '异形剑玉', en: 'Novelty', ja: '異形けん玉' },
};
